import { ColorMap } from "@potoo-modules/constants";
import Potoo_logotype_data from "./svg/Potoo-logotype.svg";
import Potoo_symbol_logotype_data from "./svg/Potoo-symbol-logotype.svg";
import Potoo_symbol_data from "./svg/Potoo-symbol.svg";

// width랑 height 다 입력해야함
type LogoProps = {
  color: string; //className으로 적으면 됨
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  width?: number | string;
  height?: number | string;
};

const PotooLogotype = ({
  color,
  className,
  onClick,
  style,
  width = "auto",
  height = "auto",
}: LogoProps) => {
  return (
    <div
      className={className}
      style={{
        ...style,
        width: width,
        height: height,
      }}
      onClick={onClick}
    >
      <Potoo_logotype_data fill={ColorMap[color]} />
    </div>
  );
};

const PotooSymbolLogotype = ({
  color,
  className,
  onClick,
  style,
  width = "auto",
  height = "auto",
}: LogoProps) => {
  return (
    <div
      className={className}
      style={{
        ...style,
        width: width,
        height: height,
      }}
      onClick={onClick}
    >
      <Potoo_symbol_logotype_data fill={ColorMap[color]} />
    </div>
  );
};

const PotooSymbol = ({
  color,
  className,
  onClick,
  style,
  width = "auto",
  height = "auto",
}: LogoProps) => {
  return (
    <div
      className={className}
      style={{
        ...style,
        width: width,
        height: height,
      }}
      onClick={onClick}
    >
      <Potoo_symbol_data fill={ColorMap[color]} />
    </div>
  );
};

export { PotooLogotype, PotooSymbolLogotype, PotooSymbol };
